import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import CustomPagination from "../../common/custompagination";
import Sorting from "../../common/sorting";
import Loader from "../../common/loader";
import Breadcrums from "../../common/breadcrumbs";
import $ from "jquery";
import { LOADER_TIMEOUT_TIME, ROLE, SWAL_SETTINGS, showFilterListAppointment, showFilterlist } from "../../../../utils/Constants";
import { capitalizeFirstLetter, extractTime, formateDate, formateDateWithMonth, getDateWithTime, handleServerValidations, removeSpecialCharacter, TrimText } from "../../../../utils/commonfunction";
import StatusFilter from "../../common/statusFilter";
import CustomRangepicker from "../../common/rangepicker";
import * as WalletService from "../../../center/services/wallet.services";
import { useFormik } from "formik";
import { DatePicker, Drawer } from "rsuite";
import CustomError from "../../../../utils/customError";
import * as Yup from "yup";
import { list, deletePatient, changeStatus, listAppointments, editAppointments, rescheduleAppointments, feedbackAppointments, feedbackSMS } from "../../../doctor/services/patient.services";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useSelector } from "react-redux";
import moment from "moment";
import AppointmentStatusFilter from "../../common/appointmentStatusFilter";

const AppointmentsTables = () => {
    const { t } = useTranslation();
    const params = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const [List, setList] = useState([]);
    const [statsupdate, setStatusUpdate] = useState("false");
    const [featuredStatsupdate, setFeaturedStatusUpdate] = useState("false");
    const [datalength, setDataLength] = useState("");
    const [itemperpage] = useState(10);
    // const [sorting, setSorting] = useState({});
    const [sorting, setSorting] = useState({column: "appointment_date", order: -1});
    const [defaultSorting, setDefaultSorting] = useState(true);
    const [page, setPage] = useState(1);
    const [loader, setLoader] = useState(true);
    const [search, setSearch] = useState({});
    const [globalsearch, setGlobalSearch] = useState("");
    const breadcrumbs = [
        { title: t("admin.cafes.link_dashboard"), url: "/admin/dashboard/1" },
        // { title: t("sidebar_link_restaurant"), url: "" },
        { title: t("Patient Management"), url: "" },
    ];
    const [resetdate, setResetDate] = useState(false);
    const [openWithHeader, setOpenWithHeader] = useState(false);
    const [addSubmissionLoader, setAddSubmissionLoader] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [getGlobalData, setGlobalData] = useState({});

    const myGlobalData = useSelector((state) => state.globalData);
    const [selectedOption, setSelectedOption] = useState(null);
    const [modelData, setModelData] = useState({});

    useEffect(() => {
        if (myGlobalData && myGlobalData?.data) {
            setGlobalData(myGlobalData?.data);
        }
    }, [myGlobalData]);

    useEffect(() => {
        const getData = setTimeout(() => {
            if (search) {
                setLoader(true);
                const formData = new FormData();
                formData.append("page", params.pgno);
                formData.append("per_page", itemperpage);
                formData.append("sort", JSON.stringify(sorting));
                formData.append("search", JSON.stringify(search));
                formData.append("global_search", globalsearch);
                formData.append("isCompletedAppointments", true);
                formData.append("isUpcomingAppointments", false);
                listAppointments(formData, ROLE.SUPER_ADMIN)
                    .then((data) => {
                        setDataLength(data.data.total_records);
                        // setSerialNo(data.data.offset);
                        setList(data && data.data && data.data.list ? data.data.list : []);
                        //   console.log("data.data.data_ids", data.data.data_ids);

                        setPage(data && data.data && data.data.page ? data.data.page : 1);
                        setLoader(false);
                    })
                    .catch((error) => {
                        console.log("error ====> ", error);
                    });
            }
        }, 300);
        return () => clearTimeout(getData);
    }, [location, statsupdate, sorting, search, globalsearch, itemperpage, params.pgno]);

    // sorting function start
    const handleSort = (e, column) => {
        setDefaultSorting(false);
        let sort = { order: 0, column: column };
        if (e.target.classList.contains("assc")) {
            sort.order = -1;
        } else {
            sort.order = 1;
        }
        setSorting(sort);
    };
    // sorting end

    // search or filter function
    const prepareSearch = (key, value) => {
        let sr = { ...search };
        if (String(value).length > 0) {
            sr[key] = value;
        } else {
            delete sr[key];
        }
        setSearch(sr);
        params.pgno = 1;
    };
    // search or filer end

    const resetFilter = (e) => {
        e.preventDefault();
        setGlobalSearch("");
        prepareSearch();
        setSearch({});
        setResetDate(!resetdate);
        $("#defaultstatus")[0].selectedIndex = 0;
        params.pgno = 1;
    };

    // const validationSchema = Yup.object().shape({
    //     selectedOption: Yup.string()
    //         .required('Please select Yes or No'),

    //     feedback: Yup.string().when('selectedOption', {
    //         is: 'yes',
    //         then: schema =>
    //             schema
    //                 .required('Feedback is required')
    //                 .min(3, 'Feedback must be at least 3 characters'),
    //         otherwise: schema => schema.notRequired(),
    //     }),

    //     reason: Yup.string().when('selectedOption', {
    //         is: 'no',
    //         then: schema =>
    //             schema
    //                 .required('Reason is required')
    //                 .min(3, 'Reason must be at least 3 characters'),
    //         otherwise: schema => schema.notRequired(),
    //     }),
    // });

    const addForm = useFormik({
        initialValues: {
            appointment_id: "",
            feedback: "",
            reason: "",
        },
        // validationSchema: validationSchema,
        validate: (values) => {
            const errors = {};

            // if (!values.selectedOption) {
            //     errors.selectedOption = 'Please select Yes or No';
            // }
            if (selectedOption === "yes") {
                if (!values.feedback && !values.feedback.trim()) {
                    errors.feedback = "Feedback is required";
                }
            }
            if (selectedOption === "no") {
                if (!values.reason && !values.reason.trim()) {
                    errors.reason = "Reason is required";
                }
            }
            return errors;
        },
        enableReinitialize: true,
        onSubmit: (values, { resetForm }) => {
            const formData = new FormData();
            formData.append("appointment_id", values.appointment_id);

            if (selectedOption === "yes") {
                formData.append("feedback", values.feedback);
            } else if (selectedOption === "no") {
                formData.append("reason", values.reason);
            }

            feedbackAppointments(formData, ROLE.SUPER_ADMIN)
                .then((response) => {
                    if (response.success) {
                        Swal.fire({
                            icon: "success",
                            text: response.message,
                            ...SWAL_SETTINGS,
                        });
                        resetForm();
                        setShowModal(false);
                        setStatusUpdate(!statsupdate);
                        setSelectedOption("");
                    } else {
                        Swal.fire({
                            icon: "error",
                            text: handleServerValidations(response),
                            ...SWAL_SETTINGS,
                        });
                        setShowModal(false);
                    }
                })
                .catch((error) => {
                    console.log("error ====> ", error);
                });
        },
    });

    const handleClose = () => {
        setShowModal(false);
        addForm.resetForm();
        setSelectedOption("");
    };

    const sendSms = (data) => {
        const formData = new FormData();
        formData.append("phone_number", data.patient_phone_no);
        formData.append("name", data.patient_name);
        feedbackSMS(formData, ROLE.SUPER_ADMIN).then((response) => {
            if (response.success) {
                Swal.fire({
                    icon: "success",
                    text: response.message,
                    ...SWAL_SETTINGS,
                });
            } else {
                Swal.fire({
                    icon: "error",
                    text: handleServerValidations(response),
                    ...SWAL_SETTINGS,
                });
            }
        });
    };

    const viewfunction = (row) => {
        navigate("/admin/management-section/completed-appointment/view/list/1", {
            state: { appointment_id: row?._id },
        });
    };

    const headerMapping = {
        sr_no: "Sr. No.",
        appointment_id: "Appointment ID",
        patient_id: "Patient ID",
        patient_name: "Patient Name",
        center_name: "Center Name",
        doctor_name: "Doctor Name",
        appointment_date: "Appointment Date",
        appointment_time: "Appointment Time",
        feedback: "Feedback",
        reason: "Reason",
    };

    const handleExport = () => {
        const formData = new FormData();
        formData.append("page", params.pgno);
        formData.append("per_page", datalength);
        formData.append("sort", JSON.stringify(sorting));
        formData.append("search", JSON.stringify(search));
        formData.append("global_search", globalsearch);
        formData.append("isCompletedAppointments", true);

        listAppointments(formData, ROLE.SUPER_ADMIN)
            .then((data) => {
                setDataLength(data.data.total_records);

                // Filter only completed appointments
                const listData = (data?.data?.list || []).filter((item) => item?.status === "completed");

                const printData = listData.map((item, i) => {
                    const transformedItem = {};
                    const appointmentID = item?.appointment_register_id ? "#" + item?.appointment_register_id : "-";
                    const patientRegisterID = item?.patient_register_id ? "#" + item?.patient_register_id : "-";
                    const patientName = item?.patient_name ? capitalizeFirstLetter(item.patient_name) : "-";
                    const centerName = item?.center_name ? capitalizeFirstLetter(item.center_name) : "-";
                    const doctorName = item?.doctor_name ? capitalizeFirstLetter(item.doctor_name) : "-";
                    const appointmentDate = item?.appointment_date ? formateDate(item.appointment_date) : "-";
                    // const appointmentTime = item?.start_time || "-";
                    const appointmentTime = item?.appointment_date ? extractTime(item.appointment_date) : "-";
                    
                    const feedback = item?.appointment_feedback ? capitalizeFirstLetter(item.appointment_feedback) : "-";
                    const reason = Array.isArray(item?.appointment_reason)
                        ? item.appointment_reason.map(capitalizeFirstLetter).join(", ")
                        : item?.appointment_reason
                        ? capitalizeFirstLetter(item.appointment_reason)
                        : "-";


                    transformedItem[headerMapping["sr_no"]] = i + 1;
                    transformedItem[headerMapping["appointment_id"]] = appointmentID;
                    transformedItem[headerMapping["patient_id"]] = patientRegisterID;
                    transformedItem[headerMapping["patient_name"]] = patientName;
                    transformedItem[headerMapping["center_name"]] = centerName;
                    transformedItem[headerMapping["doctor_name"]] = doctorName;
                    transformedItem[headerMapping["appointment_date"]] = appointmentDate;
                    transformedItem[headerMapping["appointment_time"]] = appointmentTime;
                    transformedItem[headerMapping["feedback"]] = feedback;
                    transformedItem[headerMapping["reason"]] = reason;

                    return transformedItem;
                });

                const ws = XLSX.utils.json_to_sheet(printData, { header: Object.values(headerMapping) });
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, "Completed Appointments");
                const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
                const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
                saveAs(blob, "completedAppointments.xlsx");

                setTimeout(() => {
                    setLoader(false);
                }, LOADER_TIMEOUT_TIME);
            })
            .catch((error) => {
                console.error("Export error: ", error);
                setTimeout(() => {
                    setLoader(false);
                }, LOADER_TIMEOUT_TIME);
            });
    };

    //     const handleExport = () => {
    //     setLoader(true);

    //     const formData = new FormData();
    //     formData.append("page", 1);
    //     formData.append("per_page", datalength);
    //     formData.append("sort", JSON.stringify({}));
    //     formData.append("search", JSON.stringify({}));
    //     formData.append("global_search", globalsearch);

    //     listAppointments(formData, ROLE.SUPER_ADMIN)
    //         .then(data => {
    //             setDataLength(data.data.total_records);

    //             // Filter only completed appointments
    //             const listData = (data?.data?.list || []).filter(item => item?.status === "completed");

    //             const printData = listData.map((item) => {
    //                 const transformedItem = {};

    //                 const appointmentID = item?.appointment_register_id ? '#' + item?.appointment_register_id : "-";
    //                 const patientRegisterID = item?.patient_register_id ? '#' + item?.patient_register_id : "-";
    //                 const patientName = item?.patient_name ? capitalizeFirstLetter(item.patient_name) : "-";
    //                 const centerName = item?.center_name ? capitalizeFirstLetter(item.center_name) : "-";
    //                 const doctorName = item?.doctor_name ? capitalizeFirstLetter(item.doctor_name) : "-";
    //                 const appointmentDate = item?.appointment_date ? formateDate(item.appointment_date) : "-";
    //                 const appointmentTime = item?.start_time || "-";
    //                 const feedback = item?.appointment_feedback ? capitalizeFirstLetter(item.appointment_feedback) : "-";
    //                 const reason = item?.appointment_reason ? capitalizeFirstLetter(item.appointment_reason) : "-";

    //                 transformedItem["Appointment ID"] = appointmentID;
    //                 transformedItem["Patient ID"] = patientRegisterID;
    //                 transformedItem["Patient Name"] = patientName;
    //                 transformedItem["Center Name"] = centerName;
    //                 transformedItem["Doctor Name"] = doctorName;
    //                 transformedItem["Appointment Date"] = appointmentDate;
    //                 transformedItem["Appointment Time"] = appointmentTime;
    //                 transformedItem["Feedback"] = feedback;
    //                 transformedItem["Reason"] = reason;

    //                 return transformedItem;
    //             });

    //             const ws = XLSX.utils.json_to_sheet(printData, {
    //                 header: [
    //                     "Appointment ID",
    //                     "Patient ID",
    //                     "Patient Name",
    //                     "Center Name",
    //                     "Doctor Name",
    //                     "Appointment Date",
    //                     "Appointment Time",
    //                     "Feedback",
    //                     "Reason"
    //                 ]
    //             });
    //             const wb = XLSX.utils.book_new();
    //             XLSX.utils.book_append_sheet(wb, ws, 'Completed Appointments');
    //             const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    //             const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    //             saveAs(blob, 'feedback_appointments.xlsx');

    //             setTimeout(() => {
    //                 setLoader(false);
    //             }, LOADER_TIMEOUT_TIME);
    //         })
    //         .catch(error => {
    //             console.error("Export error: ", error);
    //             setTimeout(() => {
    //                 setLoader(false);
    //             }, LOADER_TIMEOUT_TIME);
    //         });
    // };

    return (
        <>
            <div className="animation_fade">
                <div className="row">
                    <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <h6 className="main-content-label">{/* {t("Medicine Management")} */}</h6>
                            <div className="d-flex align-items-center">
                                <div className="form-group mb-0 me-3">
                                    <div className="form-group mb-0 rangepicker_container filter_design">
                                        <i className="fa fa-search calender_icon"></i>
                                        <input
                                            type="search"
                                            className="form-control"
                                            value={globalsearch}
                                            placeholder={t("admin.filter_placeholder.input_placeholder_search")}
                                            onChange={(e) => {
                                                setGlobalSearch(e.target.value);
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="me-3">
                                    <CustomRangepicker
                                        GetDateRange={(e) => {
                                            prepareSearch("appointment_date", e);
                                        }}
                                        resetdate={resetdate}
                                    />
                                </div>
                                {/* <div className="me-3">
                  <StatusFilter
                    data={showFilterlistNew}
                    prepareSearch={prepareSearch}
                  />
                </div> */}
                                {/* <button
                  type="reset"
                  value="Reset"
                  onClick={resetFilter}
                  className="btn btn-warning float-right mr-2"
                >
                  {t("admin.filter_placeholder.btn_reset_filter")}
                </button> */}
                                {/* <button
                  className="btn ripple btn-main-primary signbtn mr-2"
                  onClick={() =>
                    navigate(`/admin/medicine-management/medicine/add`)
                  }
                >
                  {t("admin.cafes.btn_add_new")}
                </button> */}
                                <div className="me-3">
                                    <AppointmentStatusFilter data={showFilterListAppointment} prepareSearch={prepareSearch} />
                                </div>
                                <button type="reset" value="Reset" onClick={resetFilter} className="btn btn-warning float-right mr-2">
                                    {t("admin.filter_placeholder.btn_reset_filter")}
                                </button>
                                <button className="btn ripple btn-main-primary signbtn mr-2" onClick={handleExport} disabled={datalength === 0}>
                                    Export Report
                                </button>
                            </div>
                        </div>
                        <div className="table-responsive">
                            <table className="table table-bordered border-t0 key-buttons text-nowrap w-100">
                                <thead>
                                    <tr>
                                        <th>Sr. No.</th>
                                        <th>Appointment ID</th>
                                        <th>
                                            <div className="sorting_column">
                                                <span>{t("Patient ID")}</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="patient_register_id" />
                                            </div>
                                        </th>
                                        <th>
                                            <div className="sorting_column">
                                                <span>{t("Patient Name")}</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="name" />
                                            </div>
                                        </th>
                                        <th>Center Name</th>
                                        <th>Doctor Name</th>
                                        <th>Appointment Date</th>
                                        <th>Appointment Time</th>
                                        <th>Feedback</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loader ? (
                                        <tr>
                                            <td colSpan={14}>
                                                <Loader />
                                            </td>
                                        </tr>
                                    ) : (
                                        <>
                                            {List.length ? (
                                                List?.map((row, i) => (
                                                    <tr key={i}>
                                                        <td>{(page - 1) * itemperpage + i + 1}</td>
                                                        <td>{row?.appointment_register_id ? "#" + row.appointment_register_id : null}</td>
                                                        <td>{row?.patient_register_id ? "#" + row.patient_register_id : null}</td>
                                                        <td>
                                                            {row?.patient_name ? (
                                                                <div className="d-flex">{capitalizeFirstLetter(TrimText(row.patient_name, 30))}</div>
                                                            ) : (
                                                                <div className="d-flex">N/A</div>
                                                            )}
                                                        </td>
                                                        <td>{row?.center_name ? capitalizeFirstLetter(row.center_name) : "N/A"}</td>
                                                        <td>{row?.doctor_name ? capitalizeFirstLetter(row.doctor_name) : "N/A"}</td>
                                                        <td>{formateDate(row?.appointment_date)}</td>
                                                        <td>{extractTime(row?.appointment_date)}</td>
                                                        {/* <td>{row?.start_time}</td> */}
                                                        <td>{row?.feedback_status === "completed" ? <span className="text-success">Completed</span> : <span className="text-danger">Pending</span>}</td>
                                                        <td>
                                                            <div className="d-flex">
                                                                <button
                                                                    className="btn ripple btn-main-primary signbtn"
                                                                    disabled={row?.feedback_status === "completed" || row?.feedback_count >= 3}
                                                                    onClick={() => {
                                                                        addForm.setFieldValue("appointment_id", row?._id);
                                                                        setShowModal(true);
                                                                        setModelData(row);
                                                                    }}
                                                                >
                                                                    Feedback
                                                                </button>
                                                                <button
                                                                    className="btn ripple btn-success ms-2"
                                                                    onClick={() => {
                                                                        viewfunction(row);
                                                                    }}
                                                                >
                                                                    View
                                                                </button>
                                                                {row?.feedback_count >= 3 && (
                                                                    <button
                                                                        type="button"
                                                                        className="btn ripple btn-secondary ms-2"
                                                                        onClick={() => {
                                                                            sendSms(row);
                                                                        }}
                                                                    >
                                                                        Send Message
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={14} className="text-center">
                                                        {t("admin.message.msg_no_records")}
                                                    </td>
                                                </tr>
                                            )}
                                        </>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        <div className="" id="example1_info" role="status" aria-live="polite">
                            <b>
                                {t("admin.message.msg_total_records")} : {datalength ? datalength : "0"}
                            </b>
                        </div>
                        {datalength && datalength > 0 ? (
                            <CustomPagination
                                datalength={datalength}
                                itemperpage={itemperpage}
                                currentPage={page}
                                setPage={setPage}
                                pageRoute={[
                                    {
                                        name: "Patient Management",
                                        path: "/admin/management-section/completed-appointment/list",
                                    },
                                ]}
                            />
                        ) : (
                            ""
                        )}
                    </div>
                </div>
            </div>

            {/* Feedback Management Modal */}
            <div
                className={`modal fade ${showModal ? "show" : ""}`}
                id="modalAddFund"
                tabIndex="-1"
                aria-labelledby="exampleModalLabel"
                {...(!showModal && { inert: "" })}
                style={{
                    display: showModal ? "block" : "none",
                    overflow: "visible",
                    zIndex: 1050,
                }}
            >
                <div
                    className="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable"
                    style={{
                        maxWidth: "500px",
                        marginTop: "-8%",
                        overflow: "visible",
                        zIndex: 1050,
                    }}
                >
                    <div
                        className="modal-content"
                        style={{
                            overflow: "visible",
                            zIndex: 1050,
                            position: "relative",
                        }}
                    >
                        {/* Modal Header */}
                        <div className="modal-header" style={{ overflow: "visible" }}>
                            <h5 className="modal-title" id="exampleModalLabel">
                                Feedback Management
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={() => {
                                    // blur active element to prevent focus conflict
                                    document.activeElement?.blur();
                                    handleClose();
                                }}
                                aria-label="Close"
                            ></button>
                        </div>

                        {/* Modal Body */}
                        <div className="modal-body" style={{ overflow: "visible" }}>
                            <form onSubmit={addForm.handleSubmit}>
                                {/* Conditional Input Field */}
                                {selectedOption === "yes" && (
                                    <div className="mb-3">
                                        <label>
                                            Feedback:<span className="requirestar">*</span>
                                        </label>
                                        <textarea
                                            className="form-control"
                                            name="feedback"
                                            value={addForm.values.feedback}
                                            onChange={addForm.handleChange}
                                            onBlur={addForm.handleBlur}
                                            placeholder="Enter your feedback"
                                        />
                                        {addForm.touched.feedback && addForm.errors.feedback && <div className="text-danger">{addForm.errors.feedback}</div>}
                                    </div>
                                )}
                                {selectedOption === "no" && (
                                    <div className="mb-3">
                                        <label>
                                            Reason:<span className="requirestar">*</span>
                                        </label>
                                        <textarea
                                            className="form-control"
                                            name="reason"
                                            value={addForm.values.reason}
                                            onChange={addForm.handleChange}
                                            onBlur={addForm.handleBlur}
                                            placeholder="Enter your reason"
                                        />
                                        {addForm.touched.reason && addForm.errors.reason && <div className="text-danger">{addForm.errors.reason}</div>}
                                    </div>
                                )}
                                {/* Action Buttons Row */}
                                <div className="d-flex justify-content-between gap-3 mt-3">
                                    {}
                                    <button type="button" className="btn ripple btn-main-primary signbtn w-100" onClick={() => setSelectedOption("yes")}>
                                        Yes
                                    </button>
                                    <button type="button" className="btn ripple btn-secondary w-100" onClick={() => setSelectedOption("no")}>
                                        No
                                    </button>
                                    {/* {modelData.feedback_count >= 3 && (
                                        <button
                                            type="button"
                                            className="btn ripple btn-danger w-100"
                                            onClick={() => { sendSms(modelData); setSelectedOption('send_sms') }}
                                        >
                                            Send Message
                                        </button>
                                    )} */}
                                </div>

                                {/* Submit Button Aligned to Right */}
                                <div className="d-flex justify-content-end mt-4">
                                    {selectedOption === "yes" || selectedOption === "no" ? (
                                        <button type="submit" className="btn btn-dark" disabled={!selectedOption}>
                                            Submit
                                        </button>
                                    ) : null}
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal Backdrop */}
            <div className={`modal-backdrop fade ${showModal ? "show" : ""}`} style={{ display: showModal ? "block" : "none", zIndex: 1040 }}></div>
        </>
    );
};

export default AppointmentsTables;
